import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim()
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim()

// If the build ran without these settings (for example an empty variable in
// Netlify), show a clear message instead of crashing to a blank page.
export const configError =
  !/^https?:\/\/\S+$/.test(supabaseUrl) || !supabaseAnonKey
    ? 'This build is missing its Supabase settings (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY). In Netlify, check Site configuration → Environment variables for empty values, then redeploy.'
    : null

export const supabase = configError ? null : createClient(supabaseUrl, supabaseAnonKey)
